import "@/App.css";
import { lazy, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, ProtectedRoute } from "@/lib/auth";

const Home = lazy(() => import("@/components/Home"));
const LandingPageList = lazy(() => import("@/components/LandingPageList"));
const LandingPage = lazy(() => import("@/components/LandingPage"));
const BookConsultation = lazy(() => import("@/components/BookConsultation"));
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const Terms = lazy(() => import("@/pages/Terms"));
const Contact = lazy(() => import("@/pages/Contact"));

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={<div className="min-h-screen bg-navy" />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/landing-page-list" element={<LandingPageList />} />
              <Route path="/book-a-consultation" element={<BookConsultation />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/get-in-touch" element={<Contact />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="/:slug" element={<LandingPage />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
